<!-- eslint-disable max-len -->
<template>
  <v-main>
    <UseIdle
      v-slot="{ idle }"
      :timeout="30 * 1000"
    >
      {{ idle ? saveData() : '' }}
    </UseIdle>
    <v-dialog
      v-model="isImpersonated"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title>Account Locked</v-card-title>
        <v-card-text>You're account is locked while an admin is logged in. Please try again later by pressing the button below</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="checkAgain"
          >
            Check Again
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <GettingStarted v-if="currentStep === 0" />
      <v-stepper
        flat
        style="background-color: transparent;"
        alt-labels
        v-model="currentStep"
        v-show="currentStep > 0"
      >
        <StepHeader/>
        <v-row>
          <v-col cols="12">
            <v-stepper-items class="mt-12">
              <StepOne />
              <StepTwo />
              <StepThree />
              <StepFour />
              <StepFive />
              <StepSix />
              <StepSeven />
              <StepEight />
            </v-stepper-items>
          </v-col>
        </v-row>
      </v-stepper>
      <v-snackbar
        v-model="ShowSnackBar"
        :timeout="2000"
        top
        :dark="!$vuetify.theme.dark"
        :light="$vuetify.theme.dark"
      >
        {{ SnackBarMsg }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { UseIdle } from '@vueuse/components';
import GettingStarted from './GettingStarted.vue';
import StepHeader from './StepHeader.vue';
import StepOne from './Steps/1Step.vue';
import StepTwo from './Steps/2Step.vue';
import StepThree from './Steps/3Step.vue';
import StepFour from './Steps/4Step.vue';
import StepFive from './Steps/5Step.vue';
import StepSix from './Steps/6Step.vue';
import StepSeven from './Steps/7Step.vue';
import StepEight from './Steps/8Step.vue';

export default {
  name: 'FormsBase',
  components: {
    GettingStarted,
    StepHeader,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    StepSeven,
    StepEight,
    UseIdle,
  },
  data: () => ({
    temp: null,
  }),
  created() {
    const token = localStorage.getItem('token');
    if (token) {
      this.$store.dispatch('validateToken');
    }
  },
  watch: {
    currentStep(newValue, oldValue) {
      if (oldValue !== 0) {
        this.$store.commit('updateProspectStateStep', newValue);
        this.$store.dispatch('updatePacketInfo');
      }
    },
  },
  computed: {
    currentStep: {
      get() {
        return this.$store.state.stepper.currentStep;
      },
      set(value) {
        this.$store.commit('goToStep', value);
      },
    },
    SnackBarMsg() {
      return this.$store.state.snackbar.message;
    },
    ShowSnackBar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit('updateSnackbarShow', value);
      },
    },
    isImpersonated() {
      if (this.$store.state.userInfo.impersonated) {
        return false;
      }

      if (this.$store.state.prospectPacket === null) {
        return false;
      }
      return this.$store.state.prospectPacket.loggedInUser.impersonated;
    },
  },
  methods: {
    checkAgain() {
      this.$store.dispatch('GetProspectPacket');
    },
    saveData() {
      this.$store.dispatch('updatePacketInfo');
    },
  },
};
</script>

<style lang="scss">
#intro.v-list.v-sheet.theme--dark {
  background-color: transparent !important;
}
#comboTheme.theme--dark.v-list {
  background: unset !important;
  color: #FFFFFF;
}
div.theme--dark .v-picker__actions.v-card__actions {
  background: #424242;
}
div.theme--dark div.v-picker__title {
  background: gray;
}
</style>
